// JOBE-0160.1/.5: CommandCenter entry, RosterTable wired.
import { useFlagStore } from './lib/useFlagStore.js';
import { KpiRow } from './CommandCenter/KpiRow.jsx';
import { AttentionList } from './CommandCenter/AttentionList.jsx';
import { RiskHeatMap } from './CommandCenter/RiskHeatMap.jsx';
import { TrendPanel } from './CommandCenter/TrendPanel.jsx';
import { RosterTable } from './CommandCenter/RosterTable.jsx';
import './mock-wcc.js';
export function CommandCenter() {
  const isRouteEnabled = useFlagStore((s) => s.isFlagOn('wcc.route'));
  if (!isRouteEnabled) return <div className="cc-disabled"><p>Workforce Command Center not enabled.</p></div>;
  return (
    <div className="command-center">
      <header className="cc-header"><h1>Workforce Command Center</h1></header>
      <KpiRow /><AttentionList /><RiskHeatMap /><TrendPanel /><RosterTable />
    </div>
  );
}
